import styled from 'styled-components'

const AspectRatio = styled.div`
  position: relative;
  padding-bottom: ${(props) => props.ratio * 100}%;
  overflow: hidden;

  > svg,
  > img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  > iframe {
    width: 100%;
    height: 100%;
    border: 0px none;
  }

  > img {
    bottom: 0;
    max-width: 100%;
  }
`

export default AspectRatio
